export default __webpack_public_path__ + "static/media/Ballroll_00358.09a2671b.png";